/**
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../../../base/BaseComponent';
import TabsTemplate from '../../../components/TabsTemplate/TabsTemplate';

export default class positionLevel extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            navsList:[{
                    key: '',
                    name: '全部',
            }],
            currentTab:''
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getList();
        this.props.callBack&&this.props.callBack(this.state.currentTab)
    }
    getList =() =>{
        this.request({
            url: "/cm-sites-media-consumer/position/overview/getPositionTypeGrade",
            method: "get",
            callBack: (data) => {
                if(data&&data.length){
                    data.forEach(item=>{
                        item.key = item.gradeKey;
                        item.name = item.grade
                    });
                    this.state.navsList = this.state.navsList.concat(data)
                }
                this.setState({})
            }
        });
    };

    render() {
        return (
            <div style={{
                height: 55,
                lineHeight: '55px',
                paddingLeft: 32,
                borderBottom: '1px solid #ebebeb',
            }}> <TabsTemplate
                tabChange={this.onChange}
                nav={this.state.navsList}
                tabKey={this.state.currentTab}
                onResize={(offsetHeight) => {
                    if (this.tabsHeight != offsetHeight) {
                        this.tabsHeight = offsetHeight;
                        this.setState({});
                    }
                }}
            /></div>

        )
    }
    onChange = (e)=>{
        this.setState({currentTab:e},()=>{
            this.props.callBack&&this.props.callBack(this.state.currentTab)
        })
    }

}